define.alias("shared/components/shared/enterprise-modal", "settings/components/shared/enterprise-modal");